<app-shared-workshop-card
  [title]="workshop.title"
  [coverImage]="workshop.coverImage"
  [detailsLink]="workshop.courseLink"
  [rows]="cardRows"
  [actions]="cardActions"
></app-shared-workshop-card>

<dx-popup
  title="دریافت فایل‌های کارگاه"
  [(visible)]="showContentsDialog"
  [width]="500"
  [height]="'auto'"
  [showTitle]="true"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  [showCloseButton]="true"
  shadingColor="rgba(0, 0, 0, 0.05)"
>
  <div *ngIf="selectedContents?.length">
    <ul class="list-unstyled mb-0">
      <li *ngFor="let contentItem of selectedContents" class="content-item">
        <ng-icon name="lucidePaperclip" class="me-2 text-success"></ng-icon>
        <a
          href="#"
          (click)="downloadContent(contentItem); $event.preventDefault()"
          class="text-success"
        >
          {{ contentItem.file_name }}
        </a>
      </li>
    </ul>
  </div>
</dx-popup>
